import * as requestFromServer from "./PartnersCrud";
import { PartnersSlice, setLoading } from "./PartnersSlice";
import { UISlice } from "../UISlice";

const { actions: PartnersActions } = PartnersSlice;
const { actions: UIActions } = UISlice;

export const fetchPartners =
  (
    type,
    searchTerm = "",
    page = 1,
    sortBy = "",
    sortDir = "asc",
    filterByClientCategory,
    startDate,
    endDate
  ) =>
  (dispatch) => {
    dispatch(UIActions.openLoader());
    dispatch(setLoading(true));

    let fetchFunction;
    switch (type) {
      case "uncompleted":
        fetchFunction = requestFromServer.fetchUncompletedPartners;
        break;
      case "pending":
        fetchFunction = requestFromServer.fetchPendingPartners;
        break;
      case "pv-active":
        fetchFunction = requestFromServer.fetchPvActivePartners;
        break;
      case "direct":
        fetchFunction = requestFromServer.fetchDirectPartners;
        break;
      case "upliner":
        fetchFunction = requestFromServer.fetchUplinerPartners;
        break;
      case "all":
      default:
        fetchFunction = requestFromServer.fetchAllPartners;
        break;
    }

    return fetchFunction(
      searchTerm,
      page,
      sortBy,
      sortDir,
      filterByClientCategory,
      startDate,
      endDate
    )
      .then((response) => {
        if (response.data.status) {
          dispatch(
            PartnersActions.setPartnersData({
              data: response.data.data,
              paginator: response.data.paginator,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(PartnersActions.catchError(error));
      })
      .finally(() => {
        dispatch(UIActions.closeLoader());
        dispatch(setLoading(false));
      });
  };
